import { render, staticRenderFns } from "./bentijiaoyan.vue?vue&type=template&id=517e70a9&scoped=true&"
import script from "./bentijiaoyan.vue?vue&type=script&lang=ts&"
export * from "./bentijiaoyan.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "517e70a9",
  null
  
)

export default component.exports